import { render, staticRenderFns } from "./Plu.vue?vue&type=template&id=7b29a8de"
import script from "./Plu.vue?vue&type=script&lang=js"
export * from "./Plu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports